import type { EventCategoryResource, EventResource, Repository, ResourceCollection } from "@octopusdeploy/octopus-server-client";
import React from "react";
import EventListing from "~/components/EventListing/EventListing";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import { PageContent } from "~/components/PageContent/PageContent";
interface DeploymentTargetEventsPageProps {
    deploymentTargetId: string;
    loaderData: DeploymentTargetEventsPageLoaderData;
}
interface DeploymentTargetEventsPageLoaderData {
    events: ResourceCollection<EventResource>;
    eventCategories: EventCategoryResource[];
}
export async function deploymentTargeEventsPageLoader(repository: Repository, deploymentTargetId: string): Promise<DeploymentTargetEventsPageLoaderData> {
    const optimizationEnabled = isFeatureToggleEnabled("PermissionCheckOptimizationFeatureToggle");
    const events = optimizationEnabled ? await repository.Events.getUnpaginatedEvents({ regarding: [deploymentTargetId] }) : await repository.Events.list({ regarding: [deploymentTargetId] });
    const eventCategories = await repository.Events.categories({});
    return { events, eventCategories };
}
const Title = "Events";
export function DeploymentTargetEventsPage({ deploymentTargetId, loaderData }: DeploymentTargetEventsPageProps) {
    return (<PageContent header={{ title: Title }}>
            <EventListing data={loaderData.events} eventCategories={loaderData.eventCategories} regarding={[deploymentTargetId]}/>
        </PageContent>);
}
